// @flow
import * as React from 'react';
import styled from 'styled-components';
import { sprintf } from 'sprintf-js';
import Flex from 'components/Flex';
import { getCityStateString } from 'utils/address';
import ListingTypeLabel from 'components/ListingTypeLabel';
import { formatEventTime } from 'utils/idealistdayevents';
import { H4, BodySmall, BodyMicro } from 'components/Text';
import Container from 'components/Container';
import Hide from 'components/Hide';
import { distanceInWordsToNow } from 'utils/date';
import SearchTile from 'components/SearchTile';
import { LISTING_LOCATION_TYPE } from 'utils/constants';

const StyledSearchTile = styled(SearchTile)`
  a {
    text-decoration: none;
    color: black;
  }
`;

type Props = {
  hit: Object,
  'data-qa-id'?: string
};

export default class SearchHitForMap extends React.PureComponent<Props> {
  hitRef = React.createRef<Element>();

  render() {
    const { hit } = this.props;
    const {
      name,
      type,
      orgName,
      orgUrl,
      isFullTime,
      remoteOptions,
      city,
      state,
      country
    } = this.props.hit;
    const location = getCityStateString({ city, stateCode: state, country });

    const listingInfo = [];
    if (isFullTime !== undefined) {
      listingInfo.push(
        isFullTime ? getText('Full Time') : getText('Part Time')
      );
    }
    if (remoteOptions !== undefined) {
      listingInfo.push(LISTING_LOCATION_TYPE[remoteOptions.locationType]);
    }

    return (
      <div ref={this.hitRef}>
        <StyledSearchTile
          data-qa-id={this.props['data-qa-id'] || 'search-result'}
        >
          <a
            href={hit.url[USER_LOCALE]}
            target="_blank"
            rel="noopener noreferrer"
            data-qa-id="search-result-link"
          >
            <>
              <Flex mb="16px">
                <ListingTypeLabel listingType={type} />
              </Flex>
              <H4 mt={16} mb={0} color="greyishBrown">
                {name}
              </H4>
              <BodySmall mb="12px">
                {orgName && (
                  <>
                    {orgUrl ? (
                      <a
                        href={orgUrl[USER_LOCALE]}
                        data-qa-id="search-result-org-link"
                      >
                        {orgName}
                      </a>
                    ) : (
                      orgName
                    )}
                    {' | '}
                  </>
                )}
                {type === 'IDEALIST_DAY_EVENT' && (
                  <>
                    {formatEventTime(hit.localizedStarts, hit.localizedEnds)}
                    {' | '}
                  </>
                )}
                {location}
              </BodySmall>
              <BodyMicro color="battleshipGrey">
                <Container
                  display={['block', 'block', 'inline-block', 'inline-block']}
                >
                  {sprintf(getText('Posted %(postedAt)s'), {
                    postedAt: distanceInWordsToNow(hit.published * 1000)
                  })}
                </Container>
                {listingInfo.length > 0 && (
                  <Hide xs sm display="inline-block">
                    &nbsp;|&nbsp;
                  </Hide>
                )}
                {listingInfo.join(' | ')}
              </BodyMicro>
            </>
          </a>
        </StyledSearchTile>
      </div>
    );
  }
}
